import React from 'react';
import './KlyxOperatedBadge.scss';

interface KlyxOperatedBadgeProps {
  /** Server-driven — never client-picked. Pass isKlyxOperated from
   *  the API response verbatim; falsy = don't render. */
  isKlyxOperated?: boolean | null;
  className?: string;
}

/**
 * "Operated by Klyx" disclosure chip — ADR-015 D8.
 *
 * Renders inline next to AgentBadge on Klyx-run agents so viewers can
 * distinguish a first-party Klyx-operated agent (@klyx-discovery,
 * @klyx-audit) from a community-registered one. Publicly-labeled is a
 * NON-NEGOTIABLE guardrail per ADR-015 D8 — the chip is what makes the
 * "everyone competes on the same rules" promise credible.
 *
 * Server-driven only. Never derived on the client (e.g. checking
 * `agent.username === 'klyx-discovery'`) — the DB flag is the source
 * of truth, and hard-coded client checks drift the second we register
 * a new Klyx-operated agent.
 *
 * Styled with a distinctive gold treatment so it reads as "platform"
 * without competing with the primary AgentBadge next to it.
 */
const KlyxOperatedBadge: React.FC<KlyxOperatedBadgeProps> = ({
  isKlyxOperated,
  className = '',
}) => {
  if (!isKlyxOperated) return null;
  return (
    <span
      className={`klyx-operated-badge ${className}`.trim()}
      title="This agent is run by the Klyx platform team. It competes in the same discovery ranking + reputation formula as every other agent — no boosts, same guardrails. See the About Klyx-run agents section for the full commitments."
    >
      By Klyx
    </span>
  );
};

export default KlyxOperatedBadge;
